<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("RPAS") }}</h3>
      </md-toolbar>
      <br />
    </div>

    <div
      v-if="!show_page_detail"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <drones-table
        :drones="drones"
        @showEditor="showEditor"
        @showPageDetail="showPageDetail"
      />
    </div>

    <div
      v-if="show_page_detail"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <h4 class="title">{{ $t("RPAS Details") }}</h4>
          </div>
          <br />
          <md-button
            class="md-primary"
            style="width:200px"
            @click="showPageDetail(null, null)"
          >
            Go Back
          </md-button>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-48 md-xsmall-size-100 md-size-48"
            >
              <md-list class="md-double-line">
                <md-subheader>{{ $t("Information") }}</md-subheader>
                <md-list-item>
                  <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-90">
                      <md-field>
                        <label>{{ $t("Manufacturer") }}</label>
                        <md-input v-model="manufacturer" disabled></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-90">
                      <md-field>
                        <label>{{ $t("Model") }}</label>
                        <md-input v-model="model" disabled></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Registration No.") }}</label>
                        <md-input
                          v-model="registrationnumber"
                          disabled
                        ></md-input>
                      </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-45">
                      <md-field>
                        <label>{{ $t("Colour") }}</label>
                        <md-input v-model="color" disabled></md-input>
                      </md-field>
                    </div>
                  </div>
                </md-list-item>
                <br />
                <md-divider></md-divider>
                <md-subheader>{{ $t("Statistics") }}</md-subheader>
                <md-table
                  style="padding-left: 30px;"
                  table-header-color="primary"
                  class=""
                >
                  <md-table-head
                    style="font-size: 12px;"
                    v-if="usertype !== USER_TYPE.FREE"
                  >
                    {{ $t("Time to Maintenance (hours)") }}
                    <md-tooltip md-direction="top">
                      {{
                        $t(
                          "Number of flight hours between required maintenance"
                        )
                      }}
                    </md-tooltip>
                  </md-table-head>
                  <md-table-head
                    style="font-size: 12px;"
                    v-if="usertype !== USER_TYPE.FREE"
                  >
                    {{ $t("Hours Since Last Service") }}
                    <md-tooltip md-direction="top">
                      {{
                        $t(
                          "Number of flight hours since last maintenance service"
                        )
                      }}
                    </md-tooltip>
                  </md-table-head>
                  <md-table-head
                    style="font-size: 12px;"
                    v-if="usertype !== USER_TYPE.FREE"
                  >
                    {{ $t("Total (hours)") }}
                    <md-tooltip md-direction="top">{{
                      $t("Total number of logged flight hours")
                    }}</md-tooltip>
                  </md-table-head>
                  <md-table-head
                    style="font-size: 12px;"
                    v-if="usertype !== USER_TYPE.FREE"
                  >
                    {{ $t("Status") }}
                    <md-tooltip md-direction="top">
                      {{ $t("Pilot Compliance with Recency Requirement") }}
                    </md-tooltip>
                  </md-table-head>
                  <md-table-row
                    v-for="(item, position) in drones"
                    :key="position"
                  >
                    <md-table-cell
                      :md-label="$t('Threshold (hours)')"
                      v-if="
                        (usertype === USER_TYPE.ADMIN ||
                          usertype === USER_TYPE.ENTERPRISE ||
                          usertype === USER_TYPE.SUPER) &&
                          item.registrationnumber === registrationnumber
                      "
                      >{{ item.threshold }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Since last maintenance (hours)')"
                      v-if="
                        (usertype === USER_TYPE.ADMIN ||
                          usertype === USER_TYPE.ENTERPRISE ||
                          usertype === USER_TYPE.SUPER) &&
                          item.registrationnumber === registrationnumber
                      "
                      >{{
                        droneCurrentHours &&
                        droneCurrentHours.find(
                          drone => drone._id.drone === item.registrationnumber
                        )
                          ? droneCurrentHours
                              .find(
                                drone =>
                                  drone._id.drone === item.registrationnumber
                              )
                              .hours.toFixed(2)
                          : item.registrationnumber
                          ? droneMaintenance.find(
                              drone =>
                                drone.registrationnumber ===
                                item.registrationnumber
                            )
                            ? "0.00"
                            : "N/A"
                          : ""
                      }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Total (hours)')"
                      v-if="
                        (usertype === USER_TYPE.ADMIN ||
                          usertype === USER_TYPE.ENTERPRISE ||
                          usertype === USER_TYPE.SUPER) &&
                          item.registrationnumber === registrationnumber
                      "
                      >{{
                        droneTotalHours &&
                        droneTotalHours.find(
                          drone => drone._id.drone === item.registrationnumber
                        )
                          ? droneTotalHours
                              .find(
                                drone =>
                                  drone._id.drone === item.registrationnumber
                              )
                              .hours.toFixed(2)
                          : item.registrationnumber
                          ? (0.0).toFixed(2)
                          : ""
                      }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Status')"
                      v-if="
                        ((usertype === USER_TYPE.ADMIN ||
                          usertype === USER_TYPE.ENTERPRISE ||
                          usertype === USER_TYPE.SUPER) &&
                          item.threshold &&
                          droneCurrentHours &&
                          droneCurrentHours.find(
                            drone => drone._id.drone === item.registrationnumber
                          ) &&
                          droneCurrentHours.find(
                            drone => drone._id.drone === item.registrationnumber
                          ).hours < item.threshold) ||
                          (!droneCurrentHours.find(
                            drone => drone._id.drone === item.registrationnumber
                          ) &&
                            droneMaintenance.find(
                              drone =>
                                drone.registrationnumber ===
                                item.registrationnumber
                            ) &&
                            item.registrationnumber === registrationnumber)
                      "
                    >
                      <md-button
                        v-if="item.threshold"
                        class="md-just-icon md-simple md-success"
                      >
                        <md-icon>verified_user</md-icon>
                        <md-tooltip md-direction="top">OK</md-tooltip>
                      </md-button>
                    </md-table-cell>
                    <md-table-cell
                      :md-label="$t('Status')"
                      v-else-if="
                        (usertype === USER_TYPE.ADMIN ||
                          usertype === USER_TYPE.ENTERPRISE ||
                          usertype === USER_TYPE.SUPER) &&
                          item.registrationnumber === registrationnumber &&
                          item.threshold &&
                          droneCurrentHours &&
                          droneCurrentHours.find(
                            drone => drone._id.drone === item.registrationnumber
                          ) &&
                          droneCurrentHours.find(
                            drone => drone._id.drone === item.registrationnumber
                          ).hours >= item.threshold
                      "
                    >
                      <md-button class="md-just-icon md-simple md-danger">
                        <md-icon>warning</md-icon>
                        <md-tooltip md-direction="top">{{
                          $t("Maintenance Required")
                        }}</md-tooltip>
                      </md-button>
                    </md-table-cell>
                    <md-table-cell
                      :md-label="$t('Status')"
                      v-else-if="
                        (usertype === USER_TYPE.ADMIN ||
                          usertype === USER_TYPE.ENTERPRISE ||
                          usertype === USER_TYPE.SUPER) &&
                          item.registrationnumber === registrationnumber &&
                          droneCurrentHours.find(
                            drone => drone._id.drone === item.registrationnumber
                          ) &&
                          !droneCurrentHours.find(
                            drone => drone._id.drone === item.registrationnumber
                          ).hours >= item.threshold
                      "
                    >
                      <md-button class="md-just-icon md-simple md-danger">
                        <md-icon>warning</md-icon>
                        <md-tooltip md-direction="top">{{
                          $t("Maintenance not available")
                        }}</md-tooltip>
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
                <br />
                <md-divider></md-divider>
              </md-list>
            </div>

            <div
              class="md-layout-item md-medium-size-48 md-xsmall-size-100 md-size-48"
            >
              <md-list class="md-double-line">
                <md-subheader>
                  {{ $t("Maintenance History") }} &nbsp;&nbsp;&nbsp;
                  <md-button
                    class="md-simple md-just-icon md-round"
                    @click="showMaintenanceEditorDrone()"
                  >
                    <md-icon>add</md-icon>
                  </md-button>
                </md-subheader>
                <md-table
                  style="padding-left: 30px;"
                  v-model="selectedDroneMaintenance"
                  class=""
                >
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell
                      :md-label="$t('Timestamp')"
                      v-if="item.registrationnumber === registrationnumber"
                      >{{
                        new Date(item.timestamp.$date).toLocaleString("en-US")
                      }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="$t('Details')"
                      v-if="item.registrationnumber === registrationnumber"
                      style="white-space: pre-wrap;"
                      >{{ item.details }}</md-table-cell
                    >
                  </md-table-row>
                </md-table>
                <br />
                <md-divider></md-divider>
                <br />
              </md-list>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <modal v-if="editing">
      <template slot="header">
        <md-button
          class="md-just-icon md-round modal-default-button"
          @click="closeEditor"
          style="right: 20px; top: 20px;"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>flight</md-icon>
            </div>
            <h4 class="title" style="text-align:left">
              {{ $t("RPAS Details") }}
            </h4>
          </md-card-header>

          <md-card-content>
            <md-field
              :class="[
                {
                  'md-valid':
                    !errors.has('manufacturer') && touched.manufacturer
                },
                { 'md-error': errors.has('manufacturer') }
              ]"
            >
              <label for="manufacturer">{{ $t("Manufacturer") }}</label>
              <md-select
                v-model="manufacturer"
                name="manufacturer"
                v-validate="'required'"
                data-vv-name="manufacturer"
                id="manufacturer"
                @md-selected="onManufacturerSelected"
              >
                <md-option
                  v-for="(item, position) in droneOptions"
                  :key="position"
                  :value="item.manufacturer"
                  >{{ item.manufacturer }}</md-option
                >
              </md-select>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('manufacturer')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('manufacturer') && touched.manufacturer"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <md-field
              v-if="manufacturer === NOT_IN_LIST"
              :class="[
                {
                  'md-valid':
                    !errors.has('otherManufacturer') &&
                    touched.otherManufacturer
                },
                { 'md-error': errors.has('otherManufacturer') }
              ]"
            >
              <label for="model">
                {{ $t("Please type in brand of your drone") }}
              </label>
              <md-input
                name="otherManufacturer"
                data-vv-name="otherManufacturer"
                v-validate="'required|min:3'"
                v-model="otherManufacturer"
                type="text"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('otherManufacturer')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="
                    !errors.has('otherManufacturer') &&
                      touched.otherManufacturer
                  "
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <md-field
              v-if="manufacturer !== NOT_IN_LIST"
              :class="[
                { 'md-valid': !errors.has('model') && touched.model },
                { 'md-error': errors.has('model') }
              ]"
            >
              <label for="model">{{ $t("Model") }}</label>
              <md-select
                v-model="model"
                name="model"
                v-validate="model === NOT_IN_LIST ? '' : 'required'"
                data-vv-name="model"
                id="model"
                :disabled="manufacturer === ''"
              >
                <md-option
                  v-for="(item, position) in droneOptions[
                    selectedManufacturerIndex
                  ].models"
                  :key="position"
                  :value="item.name"
                >
                  {{ item.name }}
                </md-option>
              </md-select>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('model')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('model') && touched.model"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>
            <md-field
              v-if="manufacturer === NOT_IN_LIST || model === NOT_IN_LIST"
              :class="[
                {
                  'md-valid': !errors.has('otherModel') && touched.otherModel
                },
                { 'md-error': errors.has('otherModel') }
              ]"
            >
              <label for="model">
                {{ $t("Please type in model of your drone") }}
              </label>
              <md-input
                name="otherModel"
                data-vv-name="otherModel"
                v-model="otherModel"
                v-validate="'required|min:3'"
                type="text"
              />
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('otherModel')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('otherModel') && touched.otherModel"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>

            <md-field
              :class="[
                {
                  'md-valid': !errors.has('nickname') && touched.nickname
                },
                { 'md-error': errors.has('nickname') }
              ]"
            >
              <label>{{ $t("RPAS Nickname") }}</label>
              <md-input
                name="nickname"
                data-vv-name="nickname"
                v-model="nickname"
                v-validate="'min:2'"
                type="text"
              />
            </md-field>

            <md-field
              :class="[
                {
                  'md-valid':
                    !errors.has('registrationnumber') &&
                    touched.registrationnumber
                },
                { 'md-error': errors.has('registrationnumber') }
              ]"
            >
              <label>{{ $t("RPAS Registration Number") }}</label>
              <md-input
                name="registrationnumber"
                data-vv-name="registrationnumber"
                v-model="registrationnumber"
                v-validate="
                  usertype === USER_TYPE.MAAC ? 'min:2' : 'required|min:10'
                "
                type="text"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('registrationnumber')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="
                    !errors.has('registrationnumber') &&
                      touched.registrationnumber
                  "
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>

            <md-field
              :class="[
                {
                  'md-valid': !errors.has('serialno') && touched.serialno
                },
                { 'md-error': errors.has('serialno') }
              ]"
            >
              <label>{{
                usertype === USER_TYPE.MAAC
                  ? $t("MAAC Number")
                  : $t("Drone ID / Serial Number")
              }}</label>
              <md-input
                v-validate="usertype === USER_TYPE.MAAC ? 'required|length:5' : 'required|min:9'"
                name="serialno"
                data-vv-name="serialno"
                v-model="serialno"
                type="text"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('serialno')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('serialno') && touched.serialno"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>

            <div style="text-align:left">
              <md-button class="md-primary md-fileinput">
                <template>{{ $t("Upload Certificate") }}</template>
                <input type="file" @change="onUploadCertificate" />
              </md-button>
              <br />
              <label v-if="selectedFile != ''">{{ selectedFile }}</label>
              <label v-else-if="certificateFile != ''">{{
                certificateFile
              }}</label>
              <br />
            </div>
            <br />

            <md-field
              :class="[
                { 'md-valid': !errors.has('color') && touched.color },
                { 'md-error': errors.has('color') }
              ]"
            >
              <label>{{ $t("Colour") }}</label>
              <md-input
                name="color"
                data-vv-name="color"
                v-model="color"
                v-validate="'required|min:3'"
                type="text"
              />
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('color')">
                  close
                </md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('color') && touched.color"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>

            <md-field
              v-if="
                usertype === USER_TYPE.ADMIN ||
                  usertype === USER_TYPE.ENTERPRISE ||
                  usertype === USER_TYPE.SUPER
              "
              :class="[
                { 'md-valid': !errors.has('threshold') && touched.threshold },
                { 'md-error': errors.has('threshold') }
              ]"
            >
              <label>{{ $t("Service Reminder (hours)") }}</label>
              <md-input
                name="threshold"
                data-vv-name="threshold"
                v-model="threshold"
                v-validate="'required|between:10,100'"
                type="text"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('threshold')"
                  >close</md-icon
                >
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon
                  class="success"
                  v-show="!errors.has('threshold') && touched.threshold"
                  >done</md-icon
                >
              </slide-y-down-transition>
            </md-field>

            <div
              v-if="
                usertype === USER_TYPE.ADMIN ||
                  usertype === USER_TYPE.ENTERPRISE ||
                  usertype === USER_TYPE.SUPER
              "
            >
              <md-radio v-model="availability" :value="0">
                {{ $t("Available to all pilots") }}
              </md-radio>
              <md-radio v-model="availability" :value="1">
                {{ $t("Available to selected pilots") }}
              </md-radio>
            </div>

            <md-field v-if="availability === 1">
              <label>{{ $t("Select pilots") }}</label>
              <md-select
                v-model="selectedPilots"
                name="pilots"
                id="pilots"
                multiple
              >
                <md-option
                  v-for="item in pilots"
                  :key="item.license"
                  :value="item.firstname + ' ' + item.lastname"
                  >{{ item.firstname }} {{ item.lastname }}</md-option
                >
              </md-select>
            </md-field>

            <md-field v-if="usertype === USER_TYPE.ADMIN">
              <label>Wilco ID</label>
              <md-input name="wilcoid" v-model="wilcoid" type="text"></md-input>
            </md-field>
          </md-card-content>
        </md-card>
      </template>

      <template slot="footer">
        <md-button
          style="margin-right: 50px;"
          class="md-raised md-primary mt-4"
          @click="validate"
          >{{ $t("Save") }}</md-button
        >
        <md-button class="md-default md-raised mt-4" @click="deleteDrone">{{
          $t("Delete")
        }}</md-button>
      </template>
    </modal>

    <modal v-if="editingMaintenance">
      <template slot="header">
        <md-button
          class="md-just-icon md-round modal-default-button"
          @click="closeMaintenanceEditor"
          style="right: 20px; top: 20px;"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>flight</md-icon>
            </div>
            <h4 class="title" style="text-align:left">
              {{ $t("RPAS Maintenance Report") }}
            </h4>
          </md-card-header>
          <md-card-content>
            <md-field>
              <label>{{ $t("Manufacturer") }}</label>
              <md-input
                name="manufacturer"
                v-model="manufacturer"
                disabled
                type="text"
              ></md-input>
            </md-field>
            <md-field>
              <label>{{ $t("Model") }}</label>
              <md-input
                name="model"
                v-model="model"
                disabled
                type="text"
              ></md-input>
            </md-field>
            <md-field>
              <label>{{ $t("RPAS Registration Number") }}</label>
              <md-input
                name="registrationnumber"
                v-model="registrationnumber"
                disabled
                type="text"
              ></md-input>
            </md-field>
            <md-field class="md-has-value">
              <label>{{ $t("Maintenance Schedule") }}</label>
              <datetime
                input-class="md-input"
                type="datetime"
                v-model="maintenanceDate"
              ></datetime>
            </md-field>
            <md-field>
              <label>{{ $t("Details") }}</label>
              <md-textarea v-model="maintenanceDetails"></md-textarea>
            </md-field>
          </md-card-content>
        </md-card>
      </template>

      <template slot="footer">
        <md-button
          class="md-raised md-primary mt-4"
          :disabled="maintenanceDate === '' || maintenanceDetails === ''"
          @click="saveMaintenance"
          >{{ $t("Save") }}</md-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Modal } from "@/components";
import { mapFields, mapMultiRowFields } from "vuex-map-fields";
import { SlideYDownTransition } from "vue2-transitions";
import { threshold_drone_hours, USER_TYPE } from "@/const.js";
import { EventBus } from "@/helpers";
import { router } from "@/main";
import DronesTable from "./Drone/DronesTable.vue";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    DronesTable,
    Modal,
    SlideYDownTransition
  },
  data() {
    return {
      show_page_detail: false,
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      USER_TYPE: USER_TYPE,

      manufacturer: "",
      otherManufacturer: "",
      model: "",
      otherModel: "",
      registrationnumber: "",
      nickname: "",
      serialno: "",
      certificateFile: "",
      fileType: "",
      certificateData: null,
      selectedFile: "",
      selectedDrone: [],

      color: "",
      threshold: threshold_drone_hours,
      wilcoid: "",
      availability: 0,
      selectedPilots: [],
      selectedManufacturerIndex: 0,

      editing: false,
      isNew: false,
      inOnList: false,
      positionDrone: -1,

      editingMaintenance: false,
      maintenanceDate: "",
      maintenanceDetails: "",
      selectedPosition: -1,
      selectedDroneMaintenance: [],
      pulledDroneMaintenance: [],

      touched: {
        manufacturer: false,
        otherManufacturer: false,
        model: false,
        nickname: false,
        serialno: false,
        otherModel: false,
        registrationnumber: false,
        color: false,
        threshold: false,
        wilcoid: false
      },

      NOT_IN_LIST: ""
    };
  },
  watch: {
    manufacturer() {
      this.touched.manufacturer = true;
    },
    otherManufacturer() {
      this.touched.otherManufacturer = true;
    },
    model() {
      this.touched.model = true;
    },
    nickname() {
      this.touched.nickname = true;
    },
    serialno() {
      this.touched.serialno = true;
    },
    otherModel() {
      this.touched.otherModel = true;
    },
    registrationnumber() {
      this.touched.registrationnumber = true;
    },
    color() {
      this.touched.color = true;
    },
    threshold() {
      this.touched.threshold = true;
    },
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = [];
      result = this.pilots;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    editing(openModal) {
      // add menu-select custom class
      if (openModal) {
        document
          .querySelector("body")
          .classList.add("custom-memu-select-wrapper");
      } else {
        document
          .querySelector("body")
          .classList.remove("custom-memu-select-wrapper");
      }
    }
  },
  computed: {
    blur: function() {
      return this.editing;
    },
    ...mapMultiRowFields("setting", ["drones", "pilots", "droneMaintenance"]),
    ...mapMultiRowFields("drone", ["droneOptions"]),
    ...mapMultiRowFields("stats", ["droneCurrentHours", "droneTotalHours"]),
    ...mapFields("auth", ["usertype"]),
    ...mapFields("setting", ["droneQuantity"])
  },
  methods: {
    showPageDetail(drone, position) {
      if (drone != null) {
        this.selectedDrone = drone;
        this.position = position;
        this.show_page_detail = true;
        this.manufacturer = drone.manufacturer;
        this.model = drone.model;
        this.nickname = drone.nickname;
        this.serialno = drone.serialno;
        this.registrationnumber = drone.registrationnumber;
        this.color = drone.color;
        this.selectedDroneMaintenance = this.droneMaintenance.filter(
          drone => drone.registrationnumber === this.registrationnumber
        );
      } else {
        this.show_page_detail = false;
      }
    },
    onResponsiveInverted() {
      this.responsive = window.innerWidth < 768;
    },
    onManufacturerSelected(item) {
      this.selectedManufacturerIndex = this.$store.state.drone.droneOptions
        .map(e => e.manufacturer)
        .indexOf(item);
      if (this.manufacturer === this.NOT_IN_LIST) {
        this.model = this.NOT_IN_LIST;
      }
      if (this.manufacturer !== this.drones[this.positionDrone].manufacturer) {
        this.model = "";
      }
    },
    showEditor(position) {
      this.editing = true;
      if (position !== null) {
        this.positionDrone = position;
        var drone = this.drones[this.positionDrone];
        this.selectedManufacturerIndex = 0;
        this.isNew = false;
        if (drone.manufacturer !== "") {
          var manufacturerIndex = this.$store.state.drone.droneOptions.findIndex(
            e => e.manufacturer === drone.manufacturer
          );
          this.selectedManufacturerIndex = manufacturerIndex;
          if (manufacturerIndex < 0) {
            this.manufacturer = this.NOT_IN_LIST;
            this.otherManufacturer = drone.manufacturer;
            this.model = this.NOT_IN_LIST;
            this.otherModel = drone.model;
          } else {
            this.manufacturer = drone.manufacturer;
            this.otherManufacturer = "";

            var idxModel = this.$store.state.drone.droneOptions[
              manufacturerIndex
            ].models.findIndex(e => e.name === drone.model);
            if (idxModel < 0) {
              this.model = this.NOT_IN_LIST;
              this.otherModel = drone.model;
            } else {
              this.model = drone.model;
              this.otherModel = "";
            }
          }
        }

        this.nickname = drone.nickname;
        this.serialno = drone.serialno;
        this.registrationnumber = drone.registrationnumber;
        this.certificateFile = drone.certificateFile;
        this.fileType = "";
        this.certificateData = null;
        this.color = drone.color;
        this.threshold = drone.threshold;
        this.wilcoid = drone.wilcoid;
        this.availability = drone.availability ? drone.availability : 0;
        this.selectedPilots = drone.pilots ? drone.pilots : [];
      } else {
        this.isNew = true;
        this.manufacturer = "";
        this.nickname = "";
        this.serialno = "";
        this.registrationnumber = "";
        this.certificateFile = "";
        this.fileType = "";
        this.certificateData = null;
        this.color = "";
        this.threshold = 30;
        this.wilcoid = "";
        this.availability = 0;
        this.selectedPilots = "";
      }
    },
    closeEditor() {
      this.editing = false;
    },
    closeDroneEditor() {
      this.manufacturer = "";
      this.otherManufacturer = "";
      this.model = "";
      this.otherModel = "";
      this.nickname = "";
      this.serialno = "";
      this.registrationnumber = "";
      this.color = "";
      this.threshold = threshold_drone_hours;
      this.wilcoid = "";
      this.availability = 0;
      this.selectedPilots = [];
      this.editing = false;
      this.touched.manufacturer = false;
      this.touched.otherManufacturer = false;
      this.touched.model = false;
      this.touched.otherModel = false;
      this.touched.nickname = false;
      this.touched.serialno = false;
      this.touched.registrationnumber = false;
      this.touched.color = false;
      this.touched.threshold = false;
      this.showPageDetail(null, null);
    },
    showMaintenanceEditorDrone() {
      if (
        this.usertype === USER_TYPE.ADMIN ||
        this.usertype === USER_TYPE.ENTERPRISE ||
        this.usertype === USER_TYPE.SUPER
      ) {
        this.editingMaintenance = true;
      } else {
        swal
          .fire({
            title: this.$t(
              "This feature is only available for enterprise user"
            ),
            text: this.$t("Please contact us for more details"),
            type: "warning",
            confirmButtonClass: "md-button md-error",
            buttonsStyling: false
          })
          .then(() => {
            this.closeMaintenanceEditor();
          });
      }
    },
    closeMaintenanceEditor() {
      this.editingMaintenance = false;
      this.maintenanceDate = "";
      this.maintenanceDetails = "";
      this.showPageDetail(this.selectedDrone, this.position);
      this.showMaintenanceHistory(this.registrationnumber, this.position);
    },
    onUploadCertificate(e) {
      var self = this;
      const file = e.target.files[0];
      this.selectedFile = file.name;
      var fileReader = new FileReader();
      fileReader.onload = function(fileLoadedEvent) {
        var base64 = fileLoadedEvent.target.result;
        self.certificateData = base64.split(",")[1];
        self.fileType = file.type;
      };
      fileReader.readAsDataURL(file);
    },
    validate() {
      return this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          return;
        }
        if (this.isNew) {
          this.addDroneValidated();
        } else {
          this.updateDroneValidated();
        }
      });
    },
    addDroneValidated() {
      this.$store
        .dispatch("setting/addDrone", {
          position: this.positionDrone,
          manufacturer:
            this.manufacturer === this.NOT_IN_LIST
              ? this.otherManufacturer
              : this.manufacturer,
          model:
            this.manufacturer === this.NOT_IN_LIST ||
            this.model === this.NOT_IN_LIST
              ? this.otherModel
              : this.model,
          nickname: this.nickname,
          serialno: this.serialno,
          registrationnumber: this.registrationnumber,
          certificateData: this.certificateData,
          certificateFile: this.certificateFile,
          fileType: this.fileType,
          color: this.color,
          threshold: parseInt(this.threshold),
          wilcoid: this.wilcoid,
          availability: this.availability,
          pilots: this.availability === 1 ? this.selectedPilots : []
        })
        .then(() => {
          this.closeEditor();
        });
    },
    updateDroneValidated() {
      this.$store
        .dispatch("setting/updateDrone", {
          position: this.positionDrone,
          manufacturer:
            this.manufacturer === this.NOT_IN_LIST
              ? this.otherManufacturer
              : this.manufacturer,
          model:
            this.manufacturer === this.NOT_IN_LIST ||
            this.model === this.NOT_IN_LIST
              ? this.otherModel
              : this.model,
          nickname: this.nickname,
          serialno: this.serialno,
          registrationnumber: this.registrationnumber,
          certificateData: this.certificateData,
          certificateFile: this.certificateFile,
          fileType: this.fileType,
          color: this.color,
          threshold: parseInt(this.threshold),
          wilcoid: this.wilcoid,
          availability: this.availability,
          pilots: this.availability === 1 ? this.selectedPilots : []
        })
        .then(() => {
          this.closeEditor();
          this.showMaintenanceHistory(
            this.registrationnumber,
            this.positionDrone
          );
        });
    },
    deleteDrone() {
      this.$store
        .dispatch("setting/deleteDrone", { position: this.positionDrone })
        .then(() => {
          this.closeDroneEditor();
        });
    },
    saveMaintenance() {
      this.$store
        .dispatch("setting/addDroneMaintenance", {
          registrationnumber: this.registrationnumber,
          timestamp: new Date(this.maintenanceDate).toISOString(),
          details: this.maintenanceDetails
        })
        .then(() => {
          this.$store.dispatch("setting/getDroneMaintenance");
          this.closeMaintenanceEditor();
        });
    },
    showMaintenanceHistory(registrationnumber, position) {
      this.selectedPosition = position;
      this.registrationnumber = registrationnumber;
      this.selectedDroneMaintenance = this.droneMaintenance.filter(
        drone => drone.registrationnumber === this.registrationnumber
      );
    }
  },
  beforeMount() {
    const locale = window.localStorage.getItem("locale");
    this.NOT_IN_LIST =
      locale === "fr" ? "-- N'EST PAS SUR LA LISTE --" : " -- NOT IN LIST --";

    if (this.usertype === USER_TYPE.PILOT) {
      swal
        .fire({
          title: this.$t("Warning"),
          text: this.$t("Only administrator can access RPAS Setting page!"),
          type: "warning",
          confirmButtonClass: "md-button md-warning",
          buttonsStyling: false
        })
        .then(() => {
          router.push("/dashboard");
        });
    }
  },
  mounted() {
    // page refresh reload DroneOptions data
    if (!this.$store.state.drone.droneOptions.length) {
      this.$store.dispatch("drone/getDroneOptions");
    }

    if (!this.drones.length) {
      this.$store.dispatch("setting/getSettings");
    }

    if (
      this.usertype === USER_TYPE.ADMIN ||
      this.usertype === USER_TYPE.ENTERPRISE ||
      this.usertype === USER_TYPE.SUPER
    ) {
      this.$store.dispatch("setting/getDroneMaintenance");
      this.$store.dispatch("stats/getDroneTotalHours");
    }

    EventBus.$on("getDroneMaintenance", () => {
      this.selectedDroneMaintenance = this.droneMaintenance.filter(
        drone =>
          this.selectedPosition >= 0 &&
          drone.registrationnumber ===
            this.drones[this.selectedPosition].registrationnumber
      );
    });

    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    EventBus.$off("getDroneMaintenance");
    window.removeEventListener("resize", this.onResponsiveInverted);

    // Clear side effects, remove body's class
    document
      .querySelector("body")
      .classList.remove("custom-memu-select-wrapper");
  }
};
</script>

<style lang="scss">
.custom-memu-select-wrapper {
  .md-select-menu {
    max-width: 80%;

    .md-list-item-text {
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
    }
  }

  @media (min-width: 800px) {
    .md-select-menu {
      max-width: 700px;
    }
  }
}
</style>
